<script setup lang="ts">

import { ref } from "vue";
import { useViewModelInstance } from "@app/MyGarage/Types/MyGarageViewModelStore";

const button = ref();
defineExpose( { button } );

const viewModel = await useViewModelInstance();

</script>

<template>

    <div>
        <JupiterButton variant="tonal"
                       type="tel" 
                       :to="viewModel.carePlan.roadsideAssistance.phoneNumber"
                       class="flex !h-10 lg:!h-12 3xl:!h-14 w-full">
            <span ref="button"
                  class="flex items-center gap-1 3xl:gap-3">
                <Icon name="help-me:roadside-assist" class="text-3xl -mt-1 mr-1 opacity-80" />
                <span class="3xl:text-base">
                    Call For Roadside Help
                </span>
            </span>
        </JupiterButton>    
        <div class="text-xs 3xl:text-base opacity-50 text-center mt-1 lg:mt-1.5 3xl:mt-3">
            Quote policy number <strong>{{ viewModel.carePlan.roadsideAssistance.policyNumber }}</strong>
        </div>
    </div>
            
</template>